/**
 * index.ts - Business/application preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export { delivvrModule } from './delivvr';
export { grouprModule } from './groupr';

import { delivvrModule } from './delivvr';
import { grouprModule } from './groupr';

export const businessModules = [
  delivvrModule,
  grouprModule
];

export default businessModules;
